export default __webpack_public_path__ + "static/rightFrontShape-c408acf9a4640d96f01e9ac348c33f30.png";